<template>
	<div class="postcode-manager">
		<header class="flex-apart">
			<div>
				<h1 class="alpha heavy">Postcode Manager</h1>
				<template v-if="refs.tabs">
					{{ refs.tabs.selectedTab("list") }}
				</template>
			</div>
			<ul class="flex gap-1">
				<li>
					<button
						:disabled="show === 'list'" class="button button--text" @click.prevent="show = 'list'">List
					</button>
				</li>
				<li>
					<button
						:disabled="show === 'map'" class="button button--text" @click.prevent="show = 'map'">Map
					</button>
				</li>
			</ul>
		</header>
		<div>
			<div v-if="show === 'list'">
				<postcode-manager-list class="section--floating"/>
			</div>
			<postcode-manager-map v-if="show === 'map'"/>
		</div>
	</div>
</template>
<script>
import PostcodeManagerList from "./PostcodeManagerList.vue";
import PostcodeManagerMap from "./PostcodeManagerMap.vue";

export default {

	components: {
		PostcodeManagerList,
		PostcodeManagerMap,
	},

	data() {
		return {
			show: "list",
		};
	},
};
</script>

